import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/ui/auth")({
    beforeLoad: () => {
        throw redirect({ to: "/design/components/auth", replace: true });
    },
});
